import 'vuetify/styles'
import '@/sass/overrides.sass'
import '@/sass/print.sass'
import '@mdi/font/css/materialdesignicons.css'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { VFileUpload } from 'vuetify/labs/VFileUpload'
import DayJsAdapter from '@date-io/dayjs'
import { de, it, en, hr, fr, es, pt } from 'vuetify/locale'
import i18n from '@/i18n'

import dayjs, { type Dayjs } from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

/**
 * A custom DayJsAdapter that uses UTC for date handling.
 * This ensures that all dates are treated as UTC, preventing timezone-related issues like EV-336 and EV-303
 */
class UtcDayJsAdapter extends DayJsAdapter {
  date<TArg extends unknown = undefined, TRes extends unknown = TArg extends null ? null : TArg extends undefined ? Dayjs : Dayjs | null>(value?: TArg): TRes {
    if (value === null) return (null as unknown) as TRes
    if (value === undefined) return (dayjs.utc() as unknown) as TRes
    return (dayjs.utc(value as any) as unknown) as TRes
  }
}

const theme = {
  primary: '#FF7A59',
  secondary: '#FF7A59',
  accent: '#9C27b0',
  info: '#00CAE3',
  indigo: '#7f7f7f',
  error: '#db3236',
  background: '#eeeeee'
}

const VuetifyObj = createVuetify({
  theme: {
    themes: {
      dark: { colors: theme },
      light: { colors: theme },
    },
  },
  components: {
    ...components,
    VFileUpload
  },
  directives,
  icons: {
    defaultSet: 'mdi'
  },
  date: {
    adapter: UtcDayJsAdapter
  },
  locale: {
    locale: i18n.global.locale,
    fallback: 'en',
    messages: { de, en, it, hr, fr, es, pt }
  }
})

export default VuetifyObj
